import React, { useState, useEffect } from "react";
import "./Preloader.css";

const Preloader = () => {
  setTimeout(function () {
    document.querySelector("body").classList.add("loaded");
  }, 5000);
  const [rtl, setRtl] = useState(localStorage.getItem("Language") == "rtl");
  const [fr, setFr] = useState(localStorage.getItem("Language") == "fr");

  useEffect(() => {
    var rtl = document.querySelector("body").getAttribute("class");
    if (rtl) {
      if (rtl.includes("rtl")) {
        setRtl(true);
      } else {
        setRtl(false);
      }
    }
  }, []);

  return (
    <div id="loader-wrapper">
      <div style={{ display: "flex", justifyContent: "center" }}>
        <img
          src={require("../../Assets/images/besmellah.png")}
          alt="besmellah"
          class="besmellah"
        />
      </div>
      <div id="loader">
        <img class="img-fluid mb-5" src="/logo.png" alt="Makkah" />
        <p>
          {rtl
            ? `مكة والمدينة القـابـضة المـحـدودة`
            : fr
            ? ` MECQUE & LA MÉDINE HOLDINGS LIMITED`
            : `MAKKAH & AL MADINAH HOLDINGS LIMITED`}
        </p>
      </div>
      <div class="loader-section section-left"></div>
      <div class="loader-section section-right"></div>
    </div>
  );
};

export default Preloader;
